





































































































































































































































































































// import props from './common/props';
const weekdaysDefault = [0, 1, 2, 3, 4, 5, 6];
const weekdaysWork = [1, 2, 3, 4, 5];

const intervalsDefault = {
  first: 0,
  minutes: 60,
  count: 24,
  height: 48
};
enum Units {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'month'
}

import Vue from 'vue';
import { mapState, mapActions, mapGetters } from 'vuex';

import dateFormat from '@/utils/dateFormat';
import moment from 'moment-timezone';
import {
  localDateFormat,
  setPartsToUTCDate,
  setUTCPartsToDate
} from '@/utils/dateHelpers';

import {
  upperFirst,
  getPropertyFromItem,
  getNestedValue,
  searchItems,
  escapeHTML,
  deepEqual
} from '@/utils/helpers';

import {
  diffMinutes,
  validateTimestamp,
  parseDate,
  DAYS_IN_WEEK
} from './common/timestamp';

import {
  CalendarTimestamp,
  CalendarFormatter,
  CalendarTimestampFormatOptions
} from './common/types';
import { createNativeLocaleFormatter } from './common/utils';
import mixins from '@/utils/mixins';
import vcalendar from '@/mixins/calendar';
export type VCalendar = Vue & {
  prev: () => void;
  next: () => void;
  getFormatter: (format: any) => any;
};

enum DeleteOptions {
  DELETE_SINGLE_OCCURRENCE = 0,
  DELETE_FUTURE_OCCURRENCES = 1,
  DELETE_ENTIRE_EVENT_SERIES = 2
}

function formatTime(
  withTime: { hour: number; minute: number },
  ampm: boolean
): string {
  const suffix = ampm ? (withTime.hour < 12 ? 'a' : 'p') : '';
  const hour = withTime.hour % 12 || 12;
  const minute = withTime.minute;
  return minute > 0
    ? minute < 10
      ? `${hour}:0${minute}${suffix}`
      : `${hour}:${minute}${suffix}`
    : `${hour}${suffix}`;
}
import { cloneDeep, startsWith, isEmpty } from 'lodash';
import {
  CalendarEvent,
  CalendarOccurrence,
  Participant
} from '@/models/calendar';
import RRule, { Options } from 'rrule';
type AltoleapEvent = CalendarOccurrence | CalendarEvent;
export default mixins(vcalendar).extend({
  data: () => ({
    settingsDialog: false, //false
    dark: false,
    startMenu: false,
    'event-overlap-threshold': 60,
    endMenu: false,
    nowMenu: false,
    minWeeks: 1,
    colors: [
      'blue',
      'indigo',
      'deep-purple',
      'cyan',
      'green',
      'orange',
      'grey darken-1'
    ],
    names: [
      'Meeting',
      'Holiday',
      'PTO',
      'Travel',
      'Event',
      'Birthday',
      'Conference',
      'Party'
    ],

    labels: {
      today: 'today',
      todayIcon: 'mdi-calendar'
    },
    typeOptions: [
      {
        id: 'D',
        label: 'Day',
        shortcut: 'D',
        type: Units.DAY,
        size: 1,
        focus: 0.4999,
        repeat: true,
        listTimes: true,
        updateRows: true,
        schedule: false
      },
      {
        id: 'W',
        label: '4 Day',
        shortcut: 'W',
        type: Units.WEEK,
        size: 1,
        focus: 0.4999,
        repeat: true,
        listTimes: true,
        updateRows: true,
        schedule: false
      },
      {
        id: 'M',
        label: 'Month',
        shortcut: 'M',
        type: Units.MONTH,
        size: 1,
        focus: 0.4999,
        repeat: true,
        listTimes: false,
        updateRows: true,
        schedule: false
      },
      {
        id: 'Y',
        label: 'Year',
        shortcut: 'Y',
        type: Units.YEAR,
        size: 1,
        focus: 0.4999,
        repeat: true,
        listTimes: false,
        updateRows: true,
        schedule: false
      },
      {
        id: 'S',
        label: 'Schedule',
        shortcut: 'S',
        type: Units.DAY,
        size: 92,
        focus: 0.0,
        repeat: false,
        listTimes: false,
        updateRows: false,
        schedule: true
      },
      {
        id: 'X',
        label: '4 Day',
        shortcut: 'X',
        type: Units.DAY,
        size: 4,
        focus: 0.4999,
        repeat: true,
        listTimes: true,
        updateRows: true,
        schedule: false
      }
    ],
    mode: 'column',
    modeOptions: [
      { text: 'Stack', value: 'stack' },
      { text: 'Column', value: 'column' }
    ],
    weekdays: weekdaysDefault,
    weekdaysDefault,
    weekdaysWork,
    weekdaysOptions: [
      { text: 'Sunday - Saturday', value: weekdaysDefault },
      { text: 'Mon, Wed, Fri', value: [1, 3, 5] },
      { text: 'Mon - Fri', value: [1, 2, 3, 4, 5] },
      { text: 'Mon - Sun', value: [1, 2, 3, 4, 5, 6, 0] }
    ],
    intervals: intervalsDefault,
    intervalsOptions: [
      { text: 'Default', value: intervalsDefault },
      {
        text: 'Workday',
        value: { first: 16, minutes: 30, count: 20, height: 48 }
      }
    ],
    maxDays: 7,
    maxDaysOptions: [
      { text: '7 days', value: 7 },
      { text: '5 days', value: 5 },
      { text: '4 days', value: 4 },
      { text: '3 days', value: 3 }
    ],
    styleInterval: 'default',
    styleIntervalOptions: [
      { text: 'Default', value: 'default' },
      { text: 'Workday', value: 'workday' },
      { text: 'Past', value: 'past' }
    ],
    color: 'primary',
    colorOptions: [
      { text: 'Primary', value: 'primary' },
      { text: 'Secondary', value: 'secondary' },
      { text: 'Accent', value: 'accent' },
      { text: 'Red', value: 'red' },
      { text: 'Pink', value: 'pink' },
      { text: 'Purple', value: 'purple' },
      { text: 'Deep Purple', value: 'deep-purple' },
      { text: 'Indigo', value: 'indigo' },
      { text: 'Blue', value: 'blue' },
      { text: 'Light Blue', value: 'light-blue' },
      { text: 'Cyan', value: 'cyan' },
      { text: 'Teal', value: 'teal' },
      { text: 'Green', value: 'green' },
      { text: 'Light Green', value: 'light-green' },
      { text: 'Lime', value: 'lime' },
      { text: 'Yellow', value: 'yellow' },
      { text: 'Amber', value: 'amber' },
      { text: 'Orange', value: 'orange' },
      { text: 'Deep Orange', value: 'deep-orange' },
      { text: 'Brown', value: 'brown' },
      { text: 'Blue Gray', value: 'blue-gray' },
      { text: 'Gray', value: 'gray' },
      { text: 'Black', value: 'black' }
    ],
    shortIntervals: true,
    shortMonths: true,
    shortWeekdays: false,
    typeToLabel: {
      month: 'Month',
      week: 'Week',
      day: 'Day'
    },
    searchQuery: '',
    start: {} as CalendarTimestamp,
    end: {} as CalendarTimestamp,
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    searchMode: false,
    recurrence: 0,
    calendarDrawer: false,
    tab: null,
    categories: [] as any[],
    selectedCategories: [] as any[],
    eventCopy: null as any,
    dragEvent: null as any,
    dragStart: null as any,
    dragTime: null as any,
    createEvent: null as any,
    createStart: null as any,
    extendOriginal: null as any,
    detailOptions: {
      reminder: {
        minutes: 0,
        minutesList: [
          { text: 'minutes', value: 0 },
          { text: 'hours', value: 1 },
          { text: 'days', value: 2 }
        ]
      }
    }
  }),
  computed: {
    ...mapState('calendar', ['calendars', 'events', 'occurrences', 'loading']),

    ...mapGetters({
      getAccountsByName: 'accounts/getAccountsByName',
      getCalendarIds: 'calendar/getCalendarIds'
    }),
    todayDate: (): string =>
      dateFormat(new Date(), 'MMM DD, YYYY hh:mm:ssa', false),
    calendarOccurrences(): CalendarOccurrence[] {
      const getCategory = (occurrence: Partial<CalendarOccurrence>): string => {
        return `${occurrence.participants[0].attendee.first_name} ${occurrence.participants[0].attendee.last_name}`;
      };

      const newOcc = this.occurrences.map((occurrence: any) => {
        occurrence.start_time = localDateFormat(
          occurrence.date.start,
          'YYYY-MM-DD HH:mm',
          occurrence.date.timezone
        );

        occurrence.end_time = localDateFormat(
          occurrence.date.end,
          'YYYY-MM-DD HH:mm',
          occurrence.date.timezone
        );

        // occurrence.color = '#20befc';
        // Vuetify looks for end time value to determine if event is a timed value
        occurrence.timed = !!occurrence.end_time;

        if (
          Array.isArray(occurrence.participants) &&
          occurrence.participants.length
        ) {
          occurrence.category = getCategory(occurrence);
        }

        return occurrence;
      });

      return newOcc;
    },
    settingsPage: {
      get() {
        return this.settingsDialog;
      },
      set(val: boolean) {
        return this.setSettingsPage(val);
      }
    } as any,
    monthFormatter(): CalendarFormatter {
      return this.getFormatter({
        timeZone: 'UTC',
        month: 'long'
      });
    },
    title(): string {
      const { start, end } = this;
      if (!start || !end) {
        return '';
      }

      const startMonth: any = (this as any).monthFormatter(start);
      const endMonth: any = (this as any).monthFormatter(end);
      const suffixMonth = startMonth === startMonth ? '' : endMonth;

      const startYear = start.year;
      const endYear = end.year;
      const suffixYear = startYear === endYear ? '' : endYear;

      const startDay = start.day + this.nth(start.day);
      const endDay = end.day + this.nth(end.day);

      switch (this.type) {
        case 'month':
          return `${startMonth} ${startYear}`;
        case 'week':
        case 'schedule':
          return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`;
        case 'day':
          return `${startMonth} ${startDay} ${startYear}`;
      }
      return '';
    }
  },
  methods: {
    ...mapActions('calendar', [
      'getOccurrences',
      'fetchCalendars',
      'optionsCalendar',
      'optionsCalendars',
      'fetchCalendarOccurrence',
      'fetchCalendarOccurrences',
      'createCalendarEvent',
      'fetchCalendarEvent',
      'updateCalendarEvent',
      'deleteCalendarEvent',
      'updateCalendarOccurrence',
      'moveCalendarOccurrence',
      'deleteCalendarOccurrence',
      'sendCalendarEventInvite',
      'sendCalendarOccurrenceInvite'
    ]),

    ...mapActions('accounts', ['fetchAccounts']),

    updateDialog(value: boolean) {
      this.selectedOpen = value;
    },
    showIntervalLabel(interval: any) {
      return interval.minute === 0;
    },
    viewDay(val: CalendarTimestamp, event: any) {
      this.focus = val.date;
      this.type = 'day';
    },
    async updatedCalendarList(list: number[] | never[]) {
      await this.rebuild(list);
    },

    async rebuild(list?: number[] | never[]) {
      console.log('REBUILD Callback');

      await this.$nextTick();
      await this.updateRange({ start: this.start, end: this.end }, list);
    },
    async openRecurrenceSave(message = 'Recurrence choice', options?: any) {
      return await (this as any).$refs.recurrenceSaveDialog
        .open(message, options)
        .then((choice?: number) => choice);
    },
    async updateRange({ start, end }: any, list?: number[]) {
      this.getOccurrences({
        list: list ?? (await this.getCalendarIds), //[1]
        start: moment(start.date + 'T00:00:00')
          .utc()
          .format('YYYY-MM-DD[T]HH:mm:ss'),
        end: moment(end.date + 'T23:59:59')
          .utc()
          .format('YYYY-MM-DD[T]HH:mm:ss'),
        event: localStorage.getItem('current__event')
      });
      this.start = start;
      this.end = end;
    },
    setSettingsPage(value: any) {
      this.settingsDialog = value;
    },

    prev(): any {
      (this.$refs.calendar as VCalendar).prev();
    },

    next() {
      (this.$refs.calendar as VCalendar).next();
    },
    add(occurrence?: Partial<CalendarEvent>) {
      const eventDialog = (this as any).$refs.eventDialog;
      const copy = cloneDeep(occurrence);
      eventDialog.add(copy);
    },
    edit(occurrence?: Partial<CalendarOccurrence>) {
      const eventDialog = (this as any).$refs.eventDialog;
      const copy = cloneDeep(occurrence);
      eventDialog.edit(copy);
    },

    getEventColor(event: { color: string }): string {
      if (event.color === '#FFFFFF') {
        return 'primary';
      } else {
        return event.color ?? 'primary';
      }
    },

    showEvent({ nativeEvent, event }: any) {
      if (!this.dragEvent) {
        console.log(nativeEvent, event);

        const open = () => {
          this.selectedEvent = event;
          this.selectedElement = nativeEvent.target;
          setTimeout(() => (this.selectedOpen = true), 10);
        };

        if (this.selectedOpen) {
          this.selectedOpen = false;
          setTimeout(open, 10);
        } else {
          open();
        }

        nativeEvent.stopPropagation();
      }
    },

    nth(d: number): string {
      return d > 3 && d < 21
        ? 'th'
        : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10];
    },
    rnd(a: number, b: number): number {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },
    getFormatter(options: object): CalendarFormatter {
      return createNativeLocaleFormatter('en', (_tms, _short) => options);
    },

    async deleteFunc(ev: CalendarOccurrence) {
      const choice = await this.openRecurrenceSave(
        ev.recurrence.enabled
          ? 'Delete Recurring Event'
          : 'Are you sure you want to delete this event?',
        {
          width: ev.recurrence.enabled ? 300 : 370,
          recurrence: ev.recurrence.enabled
        }
      );
      switch (choice) {
        case DeleteOptions.DELETE_SINGLE_OCCURRENCE:
          await this.deleteOccurrence(ev);
          break;

        case DeleteOptions.DELETE_FUTURE_OCCURRENCES:
          //TODO: Implement future occurences delete later
          break;

        case DeleteOptions.DELETE_ENTIRE_EVENT_SERIES:
          await this.deleteEventSeries(ev);
          break;
      }
    },
    // API CALLS
    deleteOccurrence(occurrence: CalendarOccurrence) {
      const originalStartDate = new Date(occurrence.original_start);

      this.deleteCalendarOccurrence({
        calendarId: occurrence.calendar,
        eventId: occurrence.event,
        year: originalStartDate.getUTCFullYear(),
        month: originalStartDate.getUTCMonth() + 1,
        day: originalStartDate.getUTCDate(),
        hour: originalStartDate.getUTCHours(),
        minute: originalStartDate.getUTCMinutes(),
        second: originalStartDate.getUTCSeconds(),
        data: event
      })
        .then(() => {
          console.log('success deleting occurrence');
          this.updateDialog(false);
          this.rebuild();
        })
        .catch(() => {
          console.log('failed deleting occurrence');
        });
    },

    async deleteEventSeries(occurrence: CalendarOccurrence) {
      if (occurrence) {
        (this as any)
          .deleteCalendarEvent({
            calendarId: occurrence.calendar,
            eventId: occurrence.event
          })
          .then(() => {
            console.log('success deleting calendar event series');
            this.updateDialog(false);

            this.rebuild();
          })
          .catch(() => {
            console.log('failed deleting calendar event series');
          });
      } else {
        console.log('No data found in details');
      }
    },
    findExistingIndex(item: string) {
      return (this.selectedCategories || []).findIndex((i: object) =>
        deepEqual(i, item)
      );
    },
    selectCategory(data: string) {
      const internalValue = (this.selectedCategories || []).slice();
      const i = this.findExistingIndex(data);
      i !== -1 ? internalValue.splice(i, 1) : internalValue.push(data);
      this.setValue(
        internalValue.map((i: object) => {
          return i;
        })
      );
      return;
    },
    setValue(value: any) {
      const oldValue = this.selectedCategories;
      this.selectedCategories = value;
      value !== oldValue && this.$emit('change', value);
    },
    setSelectedItems() {
      const selectedItems = [];
      const values = !Array.isArray(this.selectedCategories)
        ? [this.selectedCategories]
        : this.selectedCategories;

      for (const value of values) {
        const index = this.getAccountsByName.findIndex((v: string) =>
          deepEqual(v, value)
        );

        if (index > -1) {
          selectedItems.push(this.getAccountsByName[index]);
        }
      }

      this.categories = selectedItems;
    },
    convertReminderTime(check: boolean, cond: number, time: number): number {
      const DAY = 1440;
      const HOUR = 60;
      if (check) {
        switch (cond) {
          case 0:
            break;
          case 1:
            time = time * HOUR;
            break;
          case 2:
            time = time * DAY; //(60 * 24);
            break;
          default:
            break;
        }
      }
      return time;
    },
    parseEvent(event: AltoleapEvent, options: any): Partial<AltoleapEvent> {
      if (!isEmpty(event)) {
        const parseEventParticipants = (event: AltoleapEvent) => {
          if (event.participants!.length) {
            event.participants =
              event.participants.map((participant: Participant) => {
                return { attendee: participant.attendee.id } || [];
              }) || [];
          }

          return event;
        };
        event.reminder!.minutes = this.convertReminderTime(
          event.reminder!.enabled,
          options.reminder.minutes,
          event.reminder!.minutes
        );

        event = parseEventParticipants(event);

        return event;
      } else return event;
    },

    async openChoiceDialog(
      title?: string,
      buttonOptions?: {
        left?: {
          text: string;
        };
        right?: {
          color?: string;
          text?: string;
          icon?: string;
          iconOnly?: boolean;
        };
      }
    ): Promise<boolean> {
      return await (this as any).$refs.choiceDialog
        .open(title, buttonOptions)
        .then((choice?: boolean) => choice);
    },
    async editOccurrence(event: any) {
      const originalStartDate = new Date(this.eventCopy.original_start);

      const parsedEvent = this.parseEvent(
        Object.assign({}, event),
        this.detailOptions
      );
      if (parsedEvent) {
        await this.updateCalendarOccurrence({
          calendarId: this.eventCopy.calendar,
          eventId: this.eventCopy.event,
          year: originalStartDate.getUTCFullYear(),
          month: originalStartDate.getUTCMonth() + 1,
          day: originalStartDate.getUTCDate(),
          hour: originalStartDate.getUTCHours(),
          minute: originalStartDate.getUTCMinutes(),
          second: originalStartDate.getUTCSeconds(),
          data: parsedEvent
        })
          .then(async (result: CalendarOccurrence) => {
            if (result.participants.length) {
              if (
                await this.openChoiceDialog('Send invite to participants?', {
                  left: { text: 'Dont Send' },
                  right: { text: 'Send', color: 'primary' }
                })
              ) {
                const resultDate = new Date(result.original_start);
                this.sendCalendarOccurrenceInvite({
                  calendarId: result.calendar,
                  eventId: result.event,
                  year: resultDate.getUTCFullYear(),
                  month: resultDate.getUTCMonth() + 1,
                  day: resultDate.getUTCDate(),
                  hour: resultDate.getUTCHours(),
                  minute: resultDate.getUTCMinutes(),
                  second: resultDate.getUTCSeconds()
                }).then(() => {
                  console.log('emails sent');
                });
              }
            }
          })
          .catch(() => {
            console.log('failed editing');
          });
      } else {
        console.log('No data found in details');
      }
    },

    async editEvent(event: CalendarOccurrence) {
      const parsedEvent = this.parseEvent(
        Object.assign({}, event),
        this.detailOptions
      );

      if (parsedEvent) {
        await this.updateCalendarEvent({
          calendarId: this.eventCopy.calendar,
          eventId: this.eventCopy.event,
          data: parsedEvent
        })
          .then(async (result: CalendarEvent) => {
            console.log('success editing calendar event', result);
            if (result.participants.length) {
              if (
                await this.openChoiceDialog('Send invite to participants?', {
                  left: { text: 'Dont Send' },
                  right: { text: 'Send', color: 'primary' }
                })
              ) {
                console.log('send emails');
                this.sendCalendarEventInvite({
                  calendarId: result.calendar,
                  eventId: result.id
                }).then(() => {});
              }
            }
          })
          .catch(() => {
            console.log('failed editing');
          });
      } else {
        console.log('No data found in details');
      }
    },

    startDrag({ event, timed }: any) {
      if (event && timed) {
        console.log('start drag callback');
        this.eventCopy = cloneDeep(event);
        this.dragEvent = event;
        this.dragTime = null;
        this.extendOriginal = null; //not used
      } else {
        throw new Error('Event is null or timed is not set');
      }
    },

    startTime(tms: any) {
      const mouse = this.toTime(tms);

      // edit
      if (this.dragEvent && this.dragTime === null) {
        console.log('start time callback');
        const start = new Date(this.dragEvent.date.start).getTime();

        this.dragTime = mouse - start;
      }
      // create
      else if (!this.selectedOpen) {
        this.createStart = this.roundTime(mouse);

        this.createEvent = {
          title: `(No title)`,
          color: this.$vuetify.theme.currentTheme.primary,
          date: {
            timezone: moment.tz.guess() ?? this.calendars[0].timezone,
            start: new Date(this.createStart),
            end: new Date(this.createStart)
          },
          description: '',
          location: '',
          recurrence: {
            enabled: false,
            rules: []
          },
          calendar: this.calendars[0].id,
          participants: [],
          reminder: {
            enabled: false,
            minutes: 10
          },
          conference: {
            enabled: false,
            platform: 0
          },
          timed: true
        };

        this.occurrences.push(this.createEvent);
      }
    },
    extendBottom(event: any) {
      this.createEvent = event;
      this.createStart = event.date.start;
      this.extendOriginal = event.date.end;
    },

    mouseMove(tms: any) {
      const mouse = this.toTime(tms);
      if (this.dragEvent && this.dragTime !== null) {
        const start = new Date(this.dragEvent.date.start).getTime();
        const end = new Date(this.dragEvent.date.end).getTime();
        const duration = end - start;

        const newStartTime = mouse - this.dragTime;
        const newStart = this.roundTime(newStartTime);
        const newEnd = newStart + duration;
        this.dragEvent.date.start = new Date(newStart);
        this.dragEvent.date.end = new Date(newEnd);
      }
      //  CREATE
      else if (this.createEvent && this.createStart !== null) {
        const mouseRounded = this.roundTime(mouse, 15, false);
        const min = Math.min(mouseRounded, this.createStart);
        const max = Math.max(mouseRounded, this.createStart);

        this.createEvent.date.start = new Date(min);
        this.createEvent.date.end = new Date(max);
      }
    },
    resetDrag() {
      this.dragTime = null;
      this.dragEvent = null;
      this.eventCopy = null;
      this.createEvent = null;
      this.createStart = null;
      this.extendOriginal = null;
    },
    updateRule() {
      // this.ruleOptions = mergeDeep(this.recurrenceRule, patterns);

      const ruleFromDragEvent = RRule.fromString(
        this.dragEvent.recurrence.rules.filter(
          (e: string) => startsWith(e, 'RR') || !startsWith(e, 'DT')
        )[0]
      );

      // using utc to get away from javascripts timezone functionality
      // causes issues uses js timezone
      const rule = RRule.optionsToString({
        ...ruleFromDragEvent.origOptions,
        dtstart: this.dragEvent.date.start
      });

      const [DSTART, RULES] = rule.split(/^RRULE:/gim);
      const ruleData = {
        enabled: true,
        rules: [DSTART, RULES]
      };
      this.dragEvent.recurrence = ruleData;
    },

    async endDrag() {
      if (this.dragEvent && this.dragTime) {
        this.dragTime = null; // clear flag to prevent movement whie updating backend

        if (!(this.eventCopy.date.start instanceof Date))
          this.eventCopy.date.start = new Date(this.eventCopy.date.start);
        if (!(this.eventCopy.date.end instanceof Date))
          this.eventCopy.date.end = new Date(this.eventCopy.date.end);
        if (!(this.dragEvent.date.start instanceof Date))
          this.dragEvent.date.start = new Date(this.dragEvent.date.start);
        if (!(this.dragEvent.date.end instanceof Date))
          this.dragEvent.date.end = new Date(this.dragEvent.date.end);

        if (
          this.dragEvent &&
          !deepEqual(this.dragEvent.date, this.eventCopy.date)
        ) {
          if (this.dragEvent.recurrence.enabled) {
            this.updateRule();
          }
          const choice = await this.openRecurrenceSave(
            this.dragEvent.recurrence.enabled
              ? 'Edit Recurring Event'
              : 'Are you sure you want to save this event?',
            {
              width: this.dragEvent.recurrence.enabled ? 300 : 370,
              recurrence: this.dragEvent.recurrence.enabled
            }
          );
          switch (choice) {
            case 0:
              await this.editOccurrence(this.dragEvent);
              this.rebuild();
              this.$nextTick(() => {
                this.resetDrag();
              });
              break;
            case 2:
              await this.editEvent(this.dragEvent).then(() => this.rebuild());
              this.$nextTick(() => {
                this.resetDrag();
              });
              break;
            default:
              this.dragEvent.date.start = this.eventCopy.date.start;
              this.dragEvent.date.end = this.eventCopy.date.end;
              this.dragEvent.recurrence = this.eventCopy.recurrence;
              this.$nextTick(() => {
                this.resetDrag();
              });
              this.rebuild();
              break;
          }
        } else {
          this.resetDrag();
        }
      } else if (this.createEvent && this.createStart !== null) {
        console.log('end drag callback');
        this.createStart = null; // clear flag to prevent movement whie updating backend

        const open = () => {
          const eventDialog = (this as any).$refs.eventDialog;
          const copy = cloneDeep(this.createEvent);

          setTimeout(() => eventDialog.add(copy), 10);
        };

        open();

        setTimeout(() => {
          const i = this.occurrences.indexOf(this.createEvent);
          if (i !== -1) {
            this.occurrences.splice(i, 1);
          }

          this.createEvent = null;
        }, 200);
      }
    },

    async cancelDrag() {
      if (this.createEvent) {
        if (this.extendOriginal) {
          this.createEvent.date.end = this.extendOriginal;
        } else {
          const i = this.occurrences.indexOf(this.createEvent);
          if (i !== -1) {
            this.occurrences.splice(i, 1);
          }
        }
      }
    },

    roundTime(time: number, roundTo = 30, down = true) {
      const roundDownTime = roundTo * 60 * 1000;

      return down
        ? time - (time % roundDownTime)
        : time + (roundDownTime - (time % roundDownTime));
    },

    toTime(tms: any) {
      return setPartsToUTCDate(
        new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute)
      ).getTime();
    },

    rndElement(arr: any[]) {
      return arr[this.rnd(0, arr.length - 1)];
    }
  },
  async mounted() {
    (this.$refs.calendar as Vue & { checkChange: () => void }).checkChange();
    // (this.$refs.calendar as Vue & {
    //   scrollToTime: (time: string) => void;
    // }).scrollToTime('08:00');
  },

  async created() {
    await this.fetchCalendars({
      event: localStorage.getItem('current__event')
    });
    await this.fetchAccounts().then(() => {
      this.categories = this.getAccountsByName;
      this.selectedCategories = this.categories;
    });

    this.focus = this.today;
  }
});
